import * as React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { cn } from "@/lib/utils";

export interface SlideOverProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: React.ReactNode;
  header?: React.ReactNode;
  children: React.ReactNode;
  width?: number;
}

export function SlideOver({
  open,
  onOpenChange,
  title,
  header,
  children,
  width = 480,
}: SlideOverProps): React.ReactElement {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay
          className={cn(
            "fixed inset-0 z-40 bg-[oklch(20%_0.01_80_/_0.4)]",
            "motion-safe:animate-fade-in"
          )}
        />
        <Dialog.Content
          aria-describedby={undefined}
          className={cn(
            "fixed inset-y-0 right-0 z-50 flex flex-col",
            "border-l border-border-subtle bg-bg-surface shadow-rd-lg",
            "motion-safe:animate-slide-in-right",
            "w-[var(--so-w)] max-w-[100vw]"
          )}
          style={{ "--so-w": `min(${width}px, 100vw)` } as React.CSSProperties}
        >
          <div className="flex items-center gap-2 border-b border-border-subtle px-5 py-3.5">
            {header ?? (
              <Dialog.Title className="text-[14px] font-semibold tracking-tight">
                {title}
              </Dialog.Title>
            )}
            <Dialog.Close
              className={cn(
                "ml-auto grid h-7 w-7 place-items-center rounded-[5px]",
                "text-text-tertiary hover:bg-bg-muted-rd hover:text-text-primary",
                "focus-visible:shadow-rd-focus focus-visible:outline-none"
              )}
              aria-label="Fechar"
            >
              ×
            </Dialog.Close>
          </div>
          <div className="flex-1 overflow-y-auto">{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
